import React from 'react'
import { SvgIconProps } from '.'

type MenuFoldedIconProps = Record<string, any> & SvgIconProps

const MenuFolded: React.FC<MenuFoldedIconProps> = ({
  width = '1rem',
  height = '1rem',
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.667969 2.72233C0.667969 2.35414 0.966446 2.05566 1.33464 2.05566H14.668C15.0362 2.05566 15.3346 2.35414 15.3346 2.72233C15.3346 3.09052 15.0362 3.389 14.668 3.389H1.33464C0.966446 3.389 0.667969 3.09052 0.667969 2.72233Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.667969 8.49967C0.667969 8.13148 0.966446 7.83301 1.33464 7.83301H12.0013C12.3695 7.83301 12.668 8.13148 12.668 8.49967C12.668 8.86786 12.3695 9.16634 12.0013 9.16634H1.33464C0.966446 9.16634 0.667969 8.86786 0.667969 8.49967Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.667969 14.278C0.667969 13.9098 0.966446 13.6113 1.33464 13.6113H14.668C15.0362 13.6113 15.3346 13.9098 15.3346 14.278C15.3346 14.6462 15.0362 14.9447 14.668 14.9447H1.33464C0.966446 14.9447 0.667969 14.6462 0.667969 14.278Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.32018 5.51459C4.58053 5.77494 4.58053 6.19705 4.32019 6.4574L2.27744 8.50018L4.32019 10.543C4.58053 10.8033 4.58053 11.2254 4.32018 11.4858C4.05983 11.7461 3.63772 11.7461 3.37737 11.4858L0.863228 8.97158C0.602882 8.71123 0.602882 8.28913 0.863228 8.02878L3.37737 5.5146C3.63772 5.25425 4.05983 5.25425 4.32018 5.51459Z"
      />
    </svg>
  )
}

export default MenuFolded
